import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'de', 'it'],
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },

    defaultNS: 'common',
    ns: ['common'],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      // Prioritize stored preferences over browser language
      order: ['localStorage', 'cookie', 'sessionStorage', 'querystring', 'navigator', 'htmlTag'],
      // Cache user language preference
      caches: ['localStorage', 'cookie'],
      // Cookie options
      cookieMinutes: 7 * 24 * 60, // 7 days
      cookieDomain: window.location.hostname,
      // Use the same localStorage key as useLanguageSwitcher
      lookupLocalStorage: 'preferredLanguage',
    },
  });

export default i18n; 